import { Component, Input } from '@angular/core';
import { Kpi, KpiCategories, KpiKeys, KpisByKey, MilestoneName } from '@models';

@Component({
  selector: 'kpi-card',
  templateUrl: './kpi-card.component.html',
  styleUrl: './kpi-card.component.scss'
})
export class KpiCardComponent {
  @Input() category!: KpiCategories;
  @Input() kpis!: KpisByKey;
  @Input() keyMilestones?: MilestoneName[];

  kpiWidth = 220; // Changing this value will change the size of the KPIs, and the directive will adjust the number of columns accordingly
  getKpiKey(stringKey: string): KpiKeys {
    return stringKey as KpiKeys;
  }

  sortKpisByName = (a: { key: string; value: Kpi }, b: { key: string; value: Kpi }): number => {
    return a.value.name.localeCompare(b.value.name);
  };

  get kpiCount(): number {
    return Object.keys(this.kpis).length;
  }
}
